import Loader from 'component/loader'
import React from 'react'

function SideNavButtonGradient({
  type = 'button',
  disabled = false,
  label,
  processing = false,
  children,
  onClick,
  className = '',
}) {
  return (
    <button
      onClick={onClick}
      type={type}
      disabled={disabled || processing}
      className={`
        flex items-center justify-start
        w-full px-5 py-3
        text-sm font-medium
        rounded-lg
        transition-all duration-150

        ${disabled || processing
          ? 'bg-gray-400 text-white/70 cursor-not-allowed opacity-70'
          : `
            bg-[#F5821F]
            text-white
            hover:bg-[#e07018]
            active:bg-[#d16a12]
            focus:outline-none focus:ring-2 focus:ring-[#F5821F]/40 focus:ring-offset-2
          `
        }

        ${className}
      `}
    >
      {processing ? (
        <div className="flex items-center gap-3">
          <Loader className="h-4 w-4 text-white" />
          {label && <span>{label}</span>}
        </div>
      ) : (
        label || children
      )}
    </button>
  )
}

export default SideNavButtonGradient